import { render, staticRenderFns } from "./ChangePassWordModal.vue?vue&type=template&id=788504f2&scoped=true&"
import script from "./ChangePassWordModal.vue?vue&type=script&lang=js&"
export * from "./ChangePassWordModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangePassWordModal.vue?vue&type=style&index=0&id=788504f2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788504f2",
  null
  
)

export default component.exports